import React from "react";

import { useTranslation } from "react-i18next";

import t1 from '../../img/AboutUs/t1.webp'
import t2 from '../../img/AboutUs/t2.webp'
import t3 from '../../img/AboutUs/t3.webp'

import { Link } from "react-router-dom"

function Contacts () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]" dir="ltr">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
                <div className="flex flex-col md:flex-row justify-between gap-[20px]">
                    <div className="flex flex-col">
                        <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] leading-[1.4]">{t('about.37')}</p>
                        <p className="mt-[20px] open-sans text-[16px] xl:text-[20px] text-[#F26522]">{t('about.38')}</p>
                        <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6]">• {t('about.39')}</p>
                        <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6]">• {t('about.40')}</p>
                        <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6]">• {t('about.41')}</p>
                        <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6]">• {t('about.42')}</p>
                        <Link to="/form" className='mt-[50px]'>
                            <div className="contactus mr-auto hover:scale-[1.1] transition-all">
                                <p className="montserrat font-[600] text-[14px] xl:text-[16px]">{t('CompositeReinforcement.5')}</p>
                            </div>
                        </Link>
                    </div>
                    <div className="xl:w-[600px]">
                        <img src={t1} className="absolute hidden xl:block" alt="" />
                        <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] leading-[1.4] mt-[100px] md:mt-0 xl:mt-[70px] xl:ml-[20px]">{t('about.43')}</p>
                        <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6] max-w-[382px] xl:ml-[190px]">{t('about.44')}</p>
                        <div className="flex items-center gap-[23px] xl:ml-[190px] mt-[18px]">
                            <img src={t2} alt="" />
                            <p className="open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6]">+359878597382</p>
                        </div>
                        <div className="flex items-center gap-[23px] xl:ml-[190px] mt-[15px]">
                            <img src={t3} alt="" />
                            <p className="open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6]">info@compcoretech.com</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contacts;